/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { NB_AUTH_OPTIONS } from '../../auth.options';
import { getDeepFromObject } from '../../helpers';
import { NbAuthService } from '../../services/auth.service';
import { NbAuthResult } from '../../services/auth-result';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'nb-logout',
    templateUrl: './logout.component.html',
    standalone: true,
    imports: [TranslateModule]
})
export class NbLogoutComponent implements OnInit {

  redirectDelay: number = 0;
  strategy: string = '';

  constructor(protected service: NbAuthService,
              @Inject(NB_AUTH_OPTIONS) protected options = {},
              protected router: Router) {
    this.redirectDelay = this.getConfigValue('forms.logout.redirectDelay');
    this.strategy = this.getConfigValue('forms.logout.strategy');
  }

  ngOnInit(): void {
    let strategy = this.strategy;
    this.logout(this.strategy);
  }

  logout(strategy: string): void {
    console.devlog('logout performed, redirecting to: ', environment.gatewayFrontend)
    this.service.logout(strategy).subscribe((result: NbAuthResult) => {

      /* const redirect = result.getRedirect(); old method via config, revisit */
      
      // first method: After logout, go back to the client's login page.
      /* const redirect = loginPagePath();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      } */

      // new method: After logout, go back to the gateway's login page.
        setTimeout(() => {
          //ignores the port for some reason ! instead using plain JS. 
          //return this.router.navigateByUrl(environment.gatewayFrontend);
          window.location.href = environment.gatewayFrontend
        }, this.redirectDelay);

    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
